import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "time-out-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "time-out-content" }
const _hoisted_5 = { class: "time-out-content-1" }
const _hoisted_6 = { class: "time-out-modal-title-block" }
const _hoisted_7 = { class: "time-out-modal-title" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { id: "title-price" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "element" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "element" }
const _hoisted_15 = { class: "element" }
const _hoisted_16 = { class: "infoText" }
const _hoisted_17 = { id: "slow-down-the-pace" }
const _hoisted_18 = { class: "time-out-purchase-copy" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Me quedo", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "time-out-conditions" }, "Ver condiciones", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListElement = _resolveComponent("ListElement")!
  const _component_FeaturesCheckBox = _resolveComponent("FeaturesCheckBox")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      id: "time-out-mobile-image",
      src: require('@/assets/images/bg_timeout.png'),
      alt: "step1"
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      id: "time-out-exit-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exitSteps')))
    }, [
      _createElementVNode("img", {
        src: require('@/assets/images/salir.png'),
        alt: "step1"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activateStep3')))
                }, [
                  _createElementVNode("img", {
                    id: "info-icon",
                    src: require('@/assets/images/info-icon.png'),
                    alt: "info-icon"
                  }, null, 8, _hoisted_8)
                ]),
                _createElementVNode("h3", null, _toDisplayString(_ctx.content.planType), 1)
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.content.price), 1),
              _hoisted_10
            ]),
            (!_ctx.showFeatures.featuresNotIncluded)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.elementsFeatured, (element) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "elements",
                      key: element
                    }, [
                      _createElementVNode("span", _hoisted_12, [
                        _createVNode(_component_ListElement, {
                          element: element,
                          type: "inlcuded"
                        }, null, 8, ["element"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showFeatures.featuresNotIncluded)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.elementsIncluded, (element) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "elements",
                      key: element
                    }, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_ListElement, {
                          element: element,
                          type: "inlcuded"
                        }, null, 8, ["element"])
                      ])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.elementsNotIncluded, (element) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "elements",
                      key: element
                    }, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_ListElement, {
                          element: element,
                          type: "notInlcuded"
                        }, null, 8, ["element"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_FeaturesCheckBox, { onShowAllFeatures: _ctx.showAllFeatures }, null, 8, ["onShowAllFeatures"])
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.content.subtitle), 1),
        _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.content.screenTitle), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["time-out-content-2", { 'time-out-content2-active-margin': _ctx.showFeatures.featuresNotIncluded }])
      }, [
        _createElementVNode("button", {
          class: "time-out-purchase",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('timeOutPlanPurchase')))
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, _toDisplayString(_ctx.content.price), 1),
            _hoisted_19
          ])
        ]),
        (_ctx.canCancelSubscription)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "time-out-cancel",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
            }, " Quiero cancelar "))
          : _createCommentVNode("", true),
        _hoisted_20
      ], 2)
    ])
  ]))
}